import { PayloadAction } from '@reduxjs/toolkit';
import { ISenderError, ISenderProgress, ISenderStateInitial } from './sender-state.types';

export const actions = {
  setIsSendingEmail(state: ISenderStateInitial, { payload }: PayloadAction<boolean>) {
    state.isSending = payload;
  },
  setIsShowEmailErrors(state: ISenderStateInitial, { payload }: PayloadAction<boolean>) {
    state.isShowEmailErrors = payload;
  },
  resetIsSendingEmail(state: ISenderStateInitial) {
    state.isSending = false;
  },
  setSendingState(state: ISenderStateInitial, { payload }: PayloadAction<string>) {
    state.sendingStateId = payload;
  },
  resetSendingState(state: ISenderStateInitial) {
    state.sendingStateId = '';
  },
  setSendingErrors(state: ISenderStateInitial, { payload }: PayloadAction<ISenderError[]>) {
    state.progress.emailSendingErrors = [...payload];
  },
  resetSendingErrors(state: ISenderStateInitial) {
    state.progress.emailSendingErrors = [];
  },
  resetSendingIsLoading(state: ISenderStateInitial) {
    state.isLoading = false;
  },
  resetSendingProgress(state: ISenderStateInitial) {
    state.progress.totalSent = 0;
    state.progress.totalSending = 0;
    state.progress.totalBounced = 0;
    state.progress.totalComplaints = 0;
    state.progress.totalDelivered = 0;
    state.progress.status = 'none';
  },
  updateProgress(state: ISenderStateInitial, { payload }: PayloadAction<ISenderProgress>) {
    state.progress.totalSending = payload.totalSending;
    state.progress.totalSent = payload.totalSent;
    state.progress.status = payload.status;
    state.progress.totalBounced = payload.totalBounced;
    state.progress.totalComplaints = payload.totalComplaints;
    state.progress.totalDelivered = payload.totalDelivered;
  },
};
